import { createTheme } from "@mui/material";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    action: true;
  }
}

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#05668D",
      light: "#089dd9",
    },
    secondary: {
      main: "#f0f3bd",
    },

    text: {
      secondary: "rgba(61,61,61,0.6)",
      disabled: "rgba(74,74,74,0.38)",
    },
  },
  typography: {
    fontFamily: "Ubuntu",
    h1: {
      fontSize: "4rem",
      fontWeight: 500,
    },
  },

  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
        },
      },
    },

    MuiGrid: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
        },
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "white",
          color: "rgba(0, 0, 0, 0.87)",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          fontSize: "0.75rem",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginRight: "5px",
          marginLeft: "5px",
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: "action" },
          style: {
            borderRadius: 25,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 12,
            paddingBottom: 12,
            textTransform: "none",
            fontSize: "0.875rem",
            fontWeight: 500,
            borderWidth: 1,
            borderStyle: "solid",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              transform: "translateY(-1px)",
            },
          },
        },
        {
          props: { variant: "action", color: "primary" },
          style: {
            borderColor: "#05668D",
            color: "#05668D",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "#05668D",
              color: "white",
            },
          },
        },
      ],
    },
  },
});
